import http from '@/utils/http';
import { formatFilterValues, formatParamsValues } from './utils';

export interface IFilter {
  [key: string]: Array<string>;
}

export interface IRequestData {
  filters?: IFilter;
  [key: string]: any;
}

export interface IRequestOptions {
  url: string;
  method: string;
  data?: IRequestData;
  [key: string]: any;
}

const dashboardRequest =  (options: IRequestOptions) => http({...options, errorHandler:true});

export const viewRequest = (options: IRequestOptions) => {
  const { data } = options;
  const { filters={}, game_code: gameCode, ...params } = data;
  const filtersVal = formatFilterValues(filters);
  const paramsVal = formatParamsValues(params);
  return dashboardRequest({
    ...options,
    data: {
      game_code: gameCode,
      filters:filtersVal,
      ...paramsVal
    }
  });
}

export default dashboardRequest;
